export default {"src":"/_next/static/media/collaborator-selected.72e8c976.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};